define('OutSystems/ClientRuntime/modules/Native/IOutSystemsNativeHost',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isIOutSystemsNativeHost = void 0;
    function isIOutSystemsNativeHost(obj) {
        var _a;
        return !!((_a = obj) === null || _a === void 0 ? void 0 : _a.OutSystemsNative);
    }
    exports.isIOutSystemsNativeHost = isIOutSystemsNativeHost;
});
//# sourceMappingURL=IOutSystemsNativeHost.js.map;
